










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryDepositModel } from '@/models/summary-deposit';

@Component
export default class SummaryOrder extends Vue {
    @Prop({ default: null })
    private chinaAddress!: any;

    @Prop({ default: () => new SummaryDepositModel() })
    private summaryOrder!: SummaryDepositModel;

    @Prop({ default: () => ({ value: -1, name: 'Tất cả' }) })
    private selectedStatus!: any;
}
